//angular imports
import { 
  computed,
  Signal,
  signal,
  WritableSignal
} from "@angular/core";

//local imports
import {
  CategoriesNavModel,
  DepartmentsNavModel,
  ProgramsNavModel,
  ProjectsNavModel,
  RoomsNavModel,
  CatalogDataChangedMessage
} from "@app/catalog";


import { AbstractNavItem } from "@app/catalog-common";
import { IMenu, ModuleNavigatedMessage } from "@app/core";
import { Messenger } from "@app/shared";

export class CatalogMenuModel implements IMenu {
  private messenger: Messenger;
  private moduleNavigated?: Signal<ModuleNavigatedMessage>;
  private catalogDataChanged: Signal<CatalogDataChangedMessage>;

  public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);

  public items = computed(() => {
    let data = this.catalogDataChanged()?.catalogManagementData.menus();

    if (!data) {
      return [];
    }
    
    return [
      new ProgramsNavModel(this.messenger, data.programs),
      new ProjectsNavModel(this.messenger, data.projects),
      new DepartmentsNavModel(this.messenger, data.departments),
      new RoomsNavModel(this.messenger, data.rooms),
      new CategoriesNavModel(this.messenger, data.categories),
    ];
  });

  public initialize(
    messenger: Messenger,
    moduleNavigated: Signal<ModuleNavigatedMessage>,
    catalogDataChanged: Signal<CatalogDataChangedMessage>,
  ) {
    this.messenger = messenger;
    this.moduleNavigated = moduleNavigated;
    this.catalogDataChanged = catalogDataChanged;
  }

  public toggleSubMenu(navItem: AbstractNavItem) {
    if (this.moduleNavigated().menu.subMenu()) {
      this.moduleNavigated().menu.subMenu.set(null);
    } else {
      this.moduleNavigated().menu.subMenu.set(navItem);
    }
  }
}
